// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { AssetType } from '@interfaces/document.interfaces';
import { s3Asset } from '@interfaces/s3asset.interface';
import { s3AssetService } from '@services/s3asset.service';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class PDDJResolver implements Resolve<s3Asset[]> {
    constructor(private s3AssetService: s3AssetService) {}

    resolve(): Observable<s3Asset[]> {
        return this.s3AssetService.getAssets$(AssetType.PrintToDDJ);
    }
}
